import React from 'react';

import PropTypes from 'prop-types';

import { CommonButton, IconContainer, LinkButton, PseudoButton } from './styles';
import { PromoIcon } from '../PromoIcon/PromoIcon';
import { PromoText } from '../PromoText/PromoText';

const getComponent = (props) => {
    if (props.type === 'button') {
        return CommonButton;
    } else if (props.type === 'pseudo') {
        return PseudoButton;
    } else {
        return LinkButton;
    }
};

export const PromoDiskButton = ({ variant = 'secondary', size = 'small', ...props }) => {
    const Wrapper = getComponent(props);
    return (
        <Wrapper
            aria-label={props.labelText}
            variant={variant}
            type={props.type === 'button' ? props.type : null}
            href={props.href}
            onClick={props.onClick}
            isInverted={props.isInverted}
            isDisabled={props.isDisabled}
            size={size}
            isSelected={props.isSelected}
            isNavButton={props.isNavButton}
        >
            {props.iconName && (
                <IconContainer size={size}>
                    <PromoIcon name={props.iconName} />
                </IconContainer>
            )}
            {props.caption && (
                <PromoText tag="span" variant="subheader" color="primary">
                    {props.caption}
                </PromoText>
            )}
        </Wrapper>
    );
};

PromoDiskButton.propTypes = {
    type: PropTypes.oneOf(['button', 'pseudo']),
    variant: PropTypes.oneOf(['primary', 'secondary']),
    href: PropTypes.string,
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    isInverted: PropTypes.bool,
    isDisabled: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'large']),
    isSelected: PropTypes.bool,
    caption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    labelText: PropTypes.string,
    isNavButton: PropTypes.bool,
};
